module.exports = __webpack_public_path__ + "static/media/SLIM FIT.c334c78b.svg";